import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ImageView from "@/components/ImageView.vue";
import VueClipboard from "vue-clipboard2";
import RandomTag from "@/components/RandomTag.vue";
import ImageDecrypt from "@/components/ImageDecrypt.vue";
import "amfe-flexible";
import "@/assets/css/base.scss";
import "@/assets/css/animate.scss";

Vue.use(VueClipboard);
Vue.config.productionTip = false;
Vue.prototype.$api = "https://luoys.me";
Vue.component("RndTag", RandomTag);
Vue.component("ImageDecrypt", ImageDecrypt);
Vue.component("ImageView", ImageView);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
